"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_CROPS_DEGREE_DAYS_ID_cropId = exports.CREATE_REPORT_PESTS_TRAP_CATCHES_ID_insectId = exports.CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId = exports.EDIT_PESTS_BIOFIX_ID_insectId = exports.VIEW_PESTS_PHENOLOGY_ID_insectId = exports.VIEW_PESTS_TRAP_CATCHES_ID_insectId = exports.VIEW_PESTS_LARVAL_TREND_ID_insectId = exports.VIEW_PESTS_DEGREE_DAYS_ID_insectId = void 0;
const VIEW_PESTS_DEGREE_DAYS_ID_insectId = (insectId) => `VIEW_PESTS_DEGREE_DAYS_ID_${insectId}`;
exports.VIEW_PESTS_DEGREE_DAYS_ID_insectId = VIEW_PESTS_DEGREE_DAYS_ID_insectId;
const VIEW_PESTS_LARVAL_TREND_ID_insectId = (insectId) => `VIEW_PESTS_LARVAL_TREND_ID_${insectId}`;
exports.VIEW_PESTS_LARVAL_TREND_ID_insectId = VIEW_PESTS_LARVAL_TREND_ID_insectId;
const VIEW_PESTS_TRAP_CATCHES_ID_insectId = (insectId) => `VIEW_PESTS_TRAP_CATCHES_ID_${insectId}`;
exports.VIEW_PESTS_TRAP_CATCHES_ID_insectId = VIEW_PESTS_TRAP_CATCHES_ID_insectId;
const VIEW_PESTS_PHENOLOGY_ID_insectId = (insectId) => `VIEW_PESTS_PHENOLOGY_ID_${insectId}`;
exports.VIEW_PESTS_PHENOLOGY_ID_insectId = VIEW_PESTS_PHENOLOGY_ID_insectId;
const EDIT_PESTS_BIOFIX_ID_insectId = (insectId) => `EDIT_PESTS_BIOFIX_ID_${insectId}`;
exports.EDIT_PESTS_BIOFIX_ID_insectId = EDIT_PESTS_BIOFIX_ID_insectId;
const CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId = (insectId) => `CREATE_REPORT_PESTS_DEGREE_DAYS_ID_${insectId}`;
exports.CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId = CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId;
const CREATE_REPORT_PESTS_TRAP_CATCHES_ID_insectId = (insectId) => `CREATE_REPORT_PESTS_TRAP_CATCHES_ID_${insectId}`;
exports.CREATE_REPORT_PESTS_TRAP_CATCHES_ID_insectId = CREATE_REPORT_PESTS_TRAP_CATCHES_ID_insectId;
const VIEW_CROPS_DEGREE_DAYS_ID_cropId = (cropId) => `VIEW_CROPS_DEGREE_DAYS_ID_${cropId}`;
exports.VIEW_CROPS_DEGREE_DAYS_ID_cropId = VIEW_CROPS_DEGREE_DAYS_ID_cropId;
// prettier-ignore
const P = {
    ADMIN_CREATE_USERS: 'ADMIN_CREATE_USERS',
    ADMIN_EDIT_USERS: 'ADMIN_EDIT_USERS',
    ADMIN_SET_PERMISSION_DEFINITIONS: 'ADMIN_SET_PERMISSION_DEFINITIONS',
    ADMIN_SET_ROLE_DEFINITIONS: 'ADMIN_SET_ROLE_DEFINITIONS',
    API_TOKEN_MANAGE_AND_USE: 'API_TOKEN_MANAGE_AND_USE',
    EDIT_ALMOND_HULL_SPLIT_VALUES_FOR_STATIONS: 'EDIT_ALMOND_HULL_SPLIT_VALUES_FOR_STATIONS',
    EDIT_ALTERNARIA_DSV_THRESHOLD: 'EDIT_ALTERNARIA_DSV_THRESHOLD',
    EDIT_STATION_BLOOM_SETTINGS: 'EDIT_STATION_BLOOM_SETTINGS',
    EDIT_FIRE_BLIGHT_STATION_HISTORY: 'EDIT_FIRE_BLIGHT_STATION_HISTORY',
    EDIT_EVAPOTRANSPIRATION_COEFFICIENTS: 'EDIT_EVAPOTRANSPIRATION_COEFFICIENTS',
    EDIT_FERTIGATION: 'EDIT_FERTIGATION',
    EDIT_FRUIT_DENDROMETER_SETTINGS: 'EDIT_FRUIT_DENDROMETER_SETTINGS',
    EDIT_IRRIGATION_PLANNER: 'EDIT_IRRIGATION_PLANNER',
    EDIT_SERVICE_CENTER: 'EDIT_SERVICE_CENTER',
    EDIT_TREE_DENDROMETER_SETTINGS: 'EDIT_TREE_DENDROMETER_SETTINGS',
    EDIT_MANAGEMENT_ALLOWABLE_DEPLETION_DATES: 'EDIT_MANAGEMENT_ALLOWABLE_DEPLETION_DATES',
    EDIT_STATION_SOIL_SETTINGS: 'EDIT_STATION_SOIL_SETTINGS',
    EDIT_SOIL_CALIBRATION_SETTINGS: 'EDIT_SOIL_CALIBRATION_SETTINGS',
    EDIT_SOIL_DATE_OVERRIDE_SETTINGS: 'EDIT_SOIL_DATE_OVERRIDE_SETTINGS',
    EXPORT_DATA_TO_CSV: 'EXPORT_DATA_TO_CSV',
    IMPOSSIBLE_PERMISSION: 'IMPOSSIBLE_PERMISSION', // Only for development purposes. There should be no in-production references of this
    MOCK_PERMISSION: 'MOCK_PERMISSION', // Only for development purposes. There should be no in-production references of this
    PUBLISH_FROST_FAN_OPERATIONAL_DEVICE_SETTINGS: 'PUBLISH_FROST_FAN_OPERATIONAL_DEVICE_SETTINGS',
    PUBLISH_IRRIGATION_PLANNER_EVENTS_TO_CONTROL_PROVIDER: 'PUBLISH_IRRIGATION_PLANNER_EVENTS_TO_CONTROL_PROVIDER',
    VIEW_ALMA_CHAT: 'VIEW_ALMA_CHAT',
    VIEW_ALMOND_HULL_SPLIT_SUMMARY: 'VIEW_ALMOND_HULL_SPLIT_SUMMARY',
    VIEW_ALTERNARIA_DETAILS: 'VIEW_ALTERNARIA_DETAILS',
    VIEW_BEE_HOURS_DETAILS: 'VIEW_BEE_HOURS_DETAILS',
    VIEW_CHERRY_POWDERY_MILDEW_DETAILS: 'VIEW_CHERRY_POWDERY_MILDEW_DETAILS',
    VIEW_BLOOM_PREDICTION: 'VIEW_BLOOM_PREDICTION',
    VIEW_CHILL_DETAILS: 'VIEW_CHILL_DETAILS',
    VIEW_CONTROLLABLE_FROST_FAN_DETAILS: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    VIEW_EVAPOTRANSPIRATION_DETAILS: 'VIEW_EVAPOTRANSPIRATION_DETAILS',
    VIEW_EVAPOTRANSPIRATION_HEATMAP: 'VIEW_EVAPOTRANSPIRATION_HEATMAP',
    VIEW_EVAPOTRANSPIRATION_SUMMARY: 'VIEW_EVAPOTRANSPIRATION_SUMMARY',
    VIEW_FIRE_BLIGHT_DETAILS: 'VIEW_FIRE_BLIGHT_DETAILS',
    VIEW_FROST_FAN_DETAILS: 'VIEW_FROST_FAN_DETAILS',
    VIEW_FERTIGATION: 'VIEW_FERTIGATION',
    VIEW_FRUIT_GROWTH_DETAILS: 'VIEW_FRUIT_GROWTH_DETAILS',
    VIEW_GRAPE_POWDERY_MILDEW_DETAILS: 'VIEW_GRAPE_POWDERY_MILDEW_DETAILS',
    VIEW_GROWER_SPRAYS: 'VIEW_GROWER_SPRAYS',
    VIEW_LEAF_WETNESS_DETAILS: 'VIEW_LEAF_WETNESS_DETAILS',
    VIEW_INVERSION_DETAILS: 'VIEW_INVERSION_DETAILS',
    VIEW_IRRIGATION_DETAILS: 'VIEW_IRRIGATION_DETAILS',
    VIEW_IRRIGATION_FLOW_METER_DETAILS: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    VIEW_IRRIGATION_PLANNER: 'VIEW_IRRIGATION_PLANNER',
    VIEW_PLANT_STRESS_DETAILS: 'VIEW_PLANT_STRESS_DETAILS',
    VIEW_PROPERTY_CONFIGURATION: 'VIEW_PROPERTY_CONFIGURATION',
    VIEW_SOIL_MOISTURE_DETAILS: 'VIEW_SOIL_MOISTURE_DETAILS',
    VIEW_SPRAY_FORECAST: 'VIEW_SPRAY_FORECAST',
    VIEW_TEMPERATURE_HEATMAP: 'VIEW_TEMPERATURE_HEATMAP',
    VIEW_WALNUT_BLIGHT_DETAILS: 'VIEW_WALNUT_BLIGHT_DETAILS',
    VIEW_WEATHER_DETAILS: 'VIEW_WEATHER_DETAILS',
    // Admin Permissions
    ADMIN_CREATE_REGIONS: 'ADMIN_CREATE_REGIONS',
    ADMIN_VIEW_LIST_OF_ALL_USERS: 'ADMIN_VIEW_LIST_OF_ALL_USERS',
    ADMIN_VIEW_LIST_OF_ALL_PERMISSIONS: 'ADMIN_VIEW_LIST_OF_ALL_PERMISSIONS',
    ADMIN_VIEW_LIST_OF_ALL_PROPERTIES: 'ADMIN_VIEW_LIST_OF_ALL_PROPERTIES',
    ADMIN_VIEW_LIST_OF_ALL_REGIONS: 'ADMIN_VIEW_LIST_OF_ALL_REGIONS',
    ADMIN_VIEW_LIST_OF_ALL_ROLES: 'ADMIN_VIEW_LIST_OF_ALL_ROLES',
    ADMIN_SET_PROPERTY_PERMISSIONS: 'ADMIN_SET_PROPERTY_PERMISSIONS',
    ADMIN_SET_USERS_PERMISSIONS: 'ADMIN_SET_USERS_PERMISSIONS',
    ADMIN_SET_USERS_ROLES: 'ADMIN_SET_USERS_ROLES',
    ADMIN_VIEW_LIST_OF_ALL_PROPERTIES_ROLES_AND_PERMISSIONS: 'ADMIN_VIEW_LIST_OF_ALL_PROPERTIES_ROLES_AND_PERMISSIONS',
    ADMIN_SET_PROPERTY_ROLES: 'ADMIN_SET_PROPERTY_ROLES',
    EDIT_USER_ACCESS: 'EDIT_USER_ACCESS',
    ADMIN_VIEW_USER: 'ADMIN_VIEW_USER',
    ADMIN_EDIT_USER: 'ADMIN_EDIT_USER',
    EXPORT_PHEROMONE_PUR_REC: 'EXPORT_PHEROMONE_PUR_REC',
    // Semios Service Center
    // view help guides & instructions from spreadsheet
    VIEW_SSC_HELP_GUIDES: 'VIEW_SSC_HELP_GUIDES',
    VIEW_SSC_EQUIPMENT_INSTALLATION_INSTRUCTIONS: 'VIEW_SSC_EQUIPMENT_INSTALLATION_INSTRUCTIONS',
    // view all installable devices
    VIEW_SSC_INSTALLABLE_DEVICES: 'VIEW_SSC_INSTALLABLE_DEVICES',
    // view swap node reasons
    VIEW_SSC_SWAP_NODE_REASONS: 'VIEW_SSC_SWAP_NODE_REASONS',
    // view remove node reasons
    VIEW_SSC_REMOVE_NODE_REASONS: 'VIEW_SSC_REMOVE_NODE_REASONS',
    // view last node log (frontend)
    VIEW_SSC_NODE_LAST_LOG: 'VIEW_SSC_NODE_LAST_LOG',
    // view property overview
    VIEW_SSC_PROPERTY_OVERVIEW: 'VIEW_SSC_PROPERTY_OVERVIEW',
    // create new node image
    CREATE_SSC_NODE_IMAGE: 'CREATE_SSC_NODE_IMAGE',
    // view planned nodes
    VIEW_SSC_NODE_PLANNED_DISPENSERS: 'VIEW_SSC_NODE_PLANNED_DISPENSERS',
    VIEW_SSC_NODE_PLANNED_EXTERNALS: 'VIEW_SSC_NODE_PLANNED_EXTERNALS',
    VIEW_SSC_NODE_PLANNED_GATEWAYS: 'VIEW_SSC_NODE_PLANNED_GATEWAYS',
    VIEW_SSC_NODE_PLANNED_REPEATERS: 'VIEW_SSC_NODE_PLANNED_REPEATERS',
    VIEW_SSC_NODE_PLANNED_STATIONS: 'VIEW_SSC_NODE_PLANNED_STATIONS',
    VIEW_SSC_NODE_PLANNED_TRAPS: 'VIEW_SSC_NODE_PLANNED_TRAPS',
    // view active nodes
    VIEW_SSC_NODE_ACTIVE_DISPENSERS: 'VIEW_SSC_NODE_ACTIVE_DISPENSERS',
    VIEW_SSC_NODE_ACTIVE_EXTERNALS: 'VIEW_SSC_NODE_ACTIVE_EXTERNALS',
    VIEW_SSC_NODE_ACTIVE_GATEWAYS: 'VIEW_SSC_NODE_ACTIVE_GATEWAYS',
    VIEW_SSC_NODE_ACTIVE_REPEATERS: 'VIEW_SSC_NODE_ACTIVE_REPEATERS',
    VIEW_SSC_NODE_ACTIVE_STATIONS: 'VIEW_SSC_NODE_ACTIVE_STATIONS',
    VIEW_SSC_NODE_ACTIVE_TRAPS: 'VIEW_SSC_NODE_ACTIVE_TRAPS',
    // NODE/GATEWAY PERMISSIONS
    // update node config
    EDIT_SSC_UPDATE_NODE_CONFIG: 'EDIT_SSC_UPDATE_NODE_CONFIG',
    // install a planned node/gateway
    EDIT_SSC_INSTALL_PLANNED_NODE: 'EDIT_SSC_INSTALL_PLANNED_NODE',
    EDIT_SSC_INSTALL_PLANNED_GATEWAY: 'EDIT_SSC_INSTALL_PLANNED_GATEWAY',
    // reposition active node/gateway
    EDIT_SSC_REPOSITION_ACTIVE_NODE: 'EDIT_SSC_REPOSITION_ACTIVE_NODE',
    EDIT_SSC_REPOSITION_ACTIVE_GATEWAY: 'EDIT_SSC_REPOSITION_ACTIVE_GATEWAY',
    // reposition planned node/gateway
    EDIT_SSC_REPOSITION_PLANNED_NODE: 'EDIT_SSC_REPOSITION_PLANNED_NODE',
    EDIT_SSC_REPOSITION_PLANNED_GATEWAY: 'EDIT_SSC_REPOSITION_PLANNED_GATEWAY',
    // swap node/gateway
    EDIT_SSC_SWAP_NODE: 'EDIT_SSC_SWAP_NODE',
    EDIT_SSC_SWAP_GATEWAY: 'EDIT_SSC_SWAP_GATEWAY',
    // install node/gateway
    EDIT_SSC_INSTALL_NODE: 'EDIT_SSC_INSTALL_NODE',
    EDIT_SSC_INSTALL_GATEWAY: 'EDIT_SSC_INSTALL_GATEWAY',
    // remove a node/gateway
    EDIT_SSC_REMOVE_NODE: 'EDIT_SSC_REMOVE_NODE',
    EDIT_SSC_REMOVE_GATEWAY: 'EDIT_SSC_REMOVE_GATEWAY',
    // view lures
    VIEW_SSC_LURES: 'VIEW_SSC_LURES',
    // device group permissions
    EDIT_SSC_NODE_DEVICE_DENDROMETER: 'EDIT_SSC_NODE_DEVICE_DENDROMETER',
    EDIT_SSC_NODE_DEVICE_FROST_FAN: 'EDIT_SSC_NODE_DEVICE_FROST_FAN',
    EDIT_SSC_NODE_DEVICE_LEAF_WETNESS: 'EDIT_SSC_NODE_DEVICE_LEAF_WETNESS',
    EDIT_SSC_NODE_DEVICE_SOIL: 'EDIT_SSC_NODE_DEVICE_SOIL',
    EDIT_SSC_NODE_DEVICE_WATER_FLOW: 'EDIT_SSC_NODE_DEVICE_WATER_FLOW',
    EDIT_SSC_NODE_DEVICE_WEATHER: 'EDIT_SSC_NODE_DEVICE_WEATHER',
    // service issues
    VIEW_SSC_NODE_ISSUE_DISPENSERS: 'VIEW_SSC_NODE_ISSUE_DISPENSERS',
    VIEW_SSC_NODE_ISSUE_EXTERNALS: 'VIEW_SSC_NODE_ISSUE_EXTERNALS',
    VIEW_SSC_NODE_ISSUE_GATEWAYS: 'VIEW_SSC_NODE_ISSUE_GATEWAYS',
    VIEW_SSC_NODE_ISSUE_REPEATERS: 'VIEW_SSC_NODE_ISSUE_REPEATERS',
    VIEW_SSC_NODE_ISSUE_STATIONS: 'VIEW_SSC_NODE_ISSUE_STATIONS',
    VIEW_SSC_NODE_ISSUE_TRAPS: 'VIEW_SSC_NODE_ISSUE_TRAPS',
    EDIT_SSC_NODE_ISSUE_STATUS: 'EDIT_SSC_NODE_ISSUE_STATUS',
    VIEW_SSC_SERVICE_ISSUE_RESOLUTION_ACTIONS: 'VIEW_SSC_SERVICE_ISSUE_RESOLUTION_ACTIONS',
    VIEW_SIDEKICK_SUMMARIES: 'VIEW_SIDEKICK_SUMMARIES',
};
//# sourceMappingURL=permissions.js.map